export { PosterDefinition } from './cms-vod-core/poster-definitions/poster-definition.model';
